module.exports = __webpack_public_path__ + "img/audio.058779f0.svg";